import { bindActionCreators, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from '../js/common/api';
import type OrderHistoryTypes from './orderHistoryTypes';

export const cancelOrderSet = createAsyncThunk<
  OrderHistoryTypes.OrderSetActionResult,
  OrderHistoryTypes.OrderSetId
>('orderHistory/orderSet/cancel', async (orderSetId: number) => (await api.cancelOrderSet(orderSetId))?.data);

export const changeOrderSetShipping = createAsyncThunk<
  OrderHistoryTypes.OrderSetActionResult,
  { addressId: number, orderSetId: OrderHistoryTypes.OrderSetId }
>('orderHistory/orderSet/changeShipping', async ({ addressId, orderSetId }) => (await api.changeHistoryOrderSetShipping(orderSetId, addressId))?.data);

export const fetchOrderAttachments =
  createAsyncThunk('orderHistory/orderAttachments/fetch', async () => api.getAllOrderAttachments());

export const fetchOrderOrgs =
  createAsyncThunk('orderHistory/orderOrgs/fetch', async () => api.getOrderOrgs());

export const fetchOrders =
  createAsyncThunk('orderHistory/orders/fetch', async ({ page, orgId }: { orgId?: number, page: number; }) => api.getHistoryOrders({ page, orgId }));

export const fetchOrderSet =
  createAsyncThunk('orderHistory/orderSet/fetch', async (orderSetId: number) => api.getHistoryOrderSet(orderSetId));

export const fetchOrderSetShippingOptions =
  createAsyncThunk('orderHistory/orderSet/shippingOptions/fetch', async (orderSetId: number) => api.getHistoryOrderSetShippingOptions(orderSetId));

export const fetchUserRecommendations =
  createAsyncThunk('orderHistory/userRecommendations/fetch', async (userId: number) => api.getRecommendationsForUser(userId));

const orderHistoryDispatch = (dispatch) => bindActionCreators({
  cancelOrderSet,
  changeOrderSetShipping,
  fetchOrderAttachments,
  fetchOrderOrgs,
  fetchOrders,
  fetchOrderSet,
  fetchOrderSetShippingOptions,
  fetchUserRecommendations,
}, dispatch);

export default orderHistoryDispatch;
